import React from 'react';

class AlertTraining extends React.Component {
  render() {
    return (
      <div className="alert alert-info" role="alert">
        Внимание!<br/><br/>
        При выписке с тренировки менее чем за <b>6 часов</b> - <br/>
        тренировка на абонемент НЕ возвращается.
      </div>
    )
  }
}

export default AlertTraining;
